import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useDirectFeatureFlag } from '../../hooks/use-feature-flag.hook';
import { DEPLOYMENT_FEATURE_FLAG_NAME } from '../../types/feature-flags';
import './Deployment.scss';

const Deployment = (): React.JSX.Element => {
  const navigate = useNavigate();

  const isDeployment = useDirectFeatureFlag(DEPLOYMENT_FEATURE_FLAG_NAME);

  useEffect(() => {
    if (isDeployment === false) {
      void navigate(-1);
    }
  }, [isDeployment, navigate]);

  return (
    <div className='deployment-container'>
      <div>
        <h1>
          Deployment is in progress.
          <br /> You will be redirected once it is completed.
        </h1>
      </div>
    </div>
  );
};

export default Deployment;
